import { render, staticRenderFns } from "./MarketCompChart.vue?vue&type=template&id=8e1a48ac&scoped=true"
import script from "./MarketCompChart.vue?vue&type=script&lang=js"
export * from "./MarketCompChart.vue?vue&type=script&lang=js"
import style0 from "./MarketCompChart.vue?vue&type=style&index=0&id=8e1a48ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1a48ac",
  null
  
)

export default component.exports